module.exports = __webpack_public_path__ + "static/media/icon-dashboard-financial.d6f1ada8.png";